<template>
  <div class="container-fluid py-4">
    <!-- Header moderne -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-person-plus fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Création d'un Utilisateur</h2>
      </div>
      <router-link class="btn btn-primary btn-lg shadow-sm btn-clinique" :to="{ name: 'utilisateur' }">
        <i class="bi bi-arrow-left-circle me-2"></i> Retour
      </router-link>
    </div>

    <!-- Card formulaire -->
    <div class="card p-4 shadow-sm rounded card-clinique">
      <div class="row g-4">
        <!-- Nom -->
        <div class="col-md-6">
          <label for="nom" class="form-label fw-semibold">Nom</label>
          <input type="text" id="nom" v-model="user.nom" class="form-control form-control-clinique" :class="{ 'is-invalid': error.nom }" placeholder="Nom">
          <div class="invalid-feedback">{{ error.nom }}</div>
        </div>

        <!-- Prénom -->
        <div class="col-md-6">
          <label for="prenom" class="form-label fw-semibold">Prénom</label>
          <input type="text" id="prenom" v-model="user.prenom" class="form-control form-control-clinique" :class="{ 'is-invalid': error.prenom }" placeholder="Prénom">
          <div class="invalid-feedback">{{ error.prenom }}</div>
        </div>

        <!-- Nom utilisateur -->
        <div class="col-md-6">
          <label for="username" class="form-label fw-semibold">Nom utilisateur</label>
          <input type="text" id="username" v-model="user.username" class="form-control form-control-clinique" :class="{ 'is-invalid': error.username }" placeholder="Nom d'utilisateur">
          <div class="invalid-feedback">{{ error.username }}</div>
        </div>

        <!-- Email -->
        <div class="col-md-6">
          <label for="email" class="form-label fw-semibold">Email</label>
          <input type="email" id="email" v-model="user.email" class="form-control form-control-clinique" :class="{ 'is-invalid': error.email }" placeholder="Email">
          <div class="invalid-feedback">{{ error.email }}</div>
        </div>

        <!-- Mot de passe -->
        <div class="col-md-6">
          <label for="password" class="form-label fw-semibold">Mot de passe</label>
          <input type="password" id="password" v-model="user.password" class="form-control form-control-clinique" :class="{ 'is-invalid': error.password }" placeholder="Mot de passe">
          <div class="invalid-feedback">{{ error.password }}</div>
        </div>

        <!-- Confirmation -->
        <div class="col-md-6">
          <label for="confirmPassword" class="form-label fw-semibold">Confirmation</label>
          <input type="password" id="confirmPassword" v-model="user.confirmPassword" class="form-control form-control-clinique" placeholder="Confirmez le mot de passe">
        </div>

        <!-- Rôle -->
        <div class="col-md-6">
          <label for="typeUser" class="form-label fw-semibold">Rôle</label>
          <select id="typeUser" v-model="user.typeUser" class="form-select form-select-clinique" :class="{ 'is-invalid': error.type }">
            <option value="" disabled>-- Sélectionnez un rôle --</option>
            <option v-for="type in typesUser" :key="type.id" :value="type.id">{{ type.nom }}</option>
          </select>
          <div class="invalid-feedback">{{ error.type }}</div>
        </div>

        <!-- Activé ? -->
        <div class="col-md-6 d-flex align-items-center mt-3">
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" id="enabled" v-model="user.enabled">
            <label class="form-check-label ms-2 fw-semibold" for="enabled">Activé ?</label>
          </div>
        </div>
      </div>

      <!-- Boutons -->
      <div class="d-flex justify-content-end gap-3 mt-4">
        <button class="btn btn-light border shadow-sm px-4 py-2" @click="cancel">
          <i class="bi bi-x-circle me-1"></i> Annuler
        </button>
        <button class="btn btn-success shadow px-4 py-2 btn-clinique" :disabled="isLoading" @click="saveUser">
          <i class="bi bi-save me-1"></i>
          <span v-if="isLoading">Chargement...</span>
          <span v-else>Enregistrer</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {
      isLoading: false,
      user: {
        nom: '',
        prenom: '',
        username: '',
        email: '',
        password: '',
        confirmPassword: '',
        enabled: true,
        typeUser: ''
      },
      error: { nom: '', prenom: '', username: '', email: '', password: '', type: '' },
      typesUser: []
    };
  },
  methods: {
    async getTypeUser() {
      try {
        const response = await api.getItems('type_users');
        this.typesUser = response.data.data;
      } catch (error) {
        console.error("Erreur récupération types d'utilisateurs", error);
      }
    },
    validateForm() {
      this.error = {
        nom: this.user.nom ? '' : 'Le nom est requis',
        prenom: this.user.prenom ? '' : 'Le prénom est requis',
        username: this.user.username ? '' : 'Le nom d\'utilisateur est requis',
        email: this.user.email ? '' : 'L\'email est requis',
        password: this.user.password ? '' : 'Le mot de passe est requis',
        type: this.user.typeUser ? '' : 'Le rôle est requis'
      };
      if (this.user.password !== this.user.confirmPassword) {
        alert("Les mots de passe ne correspondent pas !");
        return false;
      }
      return !Object.values(this.error).some(e => e !== '');
    },
    async saveUser() {
      if (!this.validateForm() || this.isLoading) return;
      this.isLoading = true;
      try {
        await api.createItem('users', this.user);
        this.$router.push({ name: 'utilisateur' });
      } catch (error) {
        console.error("Erreur lors de la création de l'utilisateur", error);
        alert("Une erreur s'est produite lors de l'enregistrement.");
      } finally {
        this.isLoading = false;
      }
    },
    cancel() {
      this.$router.push({ name: 'utilisateur' });
    }
  },
  mounted() {
    this.getTypeUser();
  }
};
</script>

<style scoped>
/* --- Header clinique --- */
.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
  margin-bottom: 20px;
}

/* --- Card formulaire --- */
.card-clinique {
  background: #f8fafd;
  border-radius: 12px;
  border: none;
}

/* --- Champs --- */
.form-control-clinique,
.form-select-clinique {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
  padding: 10px 14px;
  transition: all 0.3s ease;
}
.form-control-clinique:focus,
.form-select-clinique:focus {
  box-shadow: 0 0 6px #0d6efd33;
  border-color: #0d6efd;
}

/* --- Boutons --- */
.btn-clinique {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  border: none;
  color: #fff;
  border-radius: 10px;
  transition: all 0.3s ease;
}
.btn-clinique:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  transform: translateY(-2px);
}
</style>
